var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-dialog',{ref:"dialog",attrs:{"width":"800","height":"700"},on:{"resolve":_vm.editHandle}},[_c('c-form',{ref:"form",attrs:{"vertical":"","unit-width":"100%"}},[_c('power-tree',{attrs:{"power-list":_vm.powerList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }